import React from 'react';
import '../../../styles/global.css';

function ComputerGraphicsProjects() {
  return (
    <div className="body-container">
      <h1>Computer Graphics Projects</h1>
      <h4>Jan 2022 - May 2022</h4>
      <h2>Explore the projects <a href='https://tangmonica.github.io/cs184/' target="_blank" rel="noopener noreferrer">here</a>.</h2>
      <p>Projects in C++ that explore a variety of computer graphics concepts, including sampling, meshes, path tracing, simulation, and more.</p>
    </div>
  );
};

export default ComputerGraphicsProjects;
